import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { PolicyType } from 'store/modules/Policies/types';
import classNames from 'classnames';
import { itemHoverColor } from 'utils/colors';
import { darken } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      backgroundColor: 'white',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '18rem',
      zIndex: 0
    },
    policy: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0.875rem',
      margin: '0.5rem',
      cursor: 'pointer',
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: itemHoverColor
      }
    },
    list: {
      listStyle: 'none',
      padding: 0,
      position: 'sticky',
      top: '1rem'
    },
    active: {
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: darken(theme.palette.primary.main, 0.2)
      },
      padding: '0.75rem',
      '& span': {
        color: 'white'
      }
    },
    title: {
      fontWeight: 700,
      color: '#4D4D4D'
    },
    subtitle: {
      fontWeigh: 400,
      color: '#4D4D4D',
      marginTop: '2px'
    }
  };
});

interface Props {
  policies: PolicyType[];
  activePolicy: number | null;
  setActivePolicy: (policyId: number | null) => void;
  showConsolidated: boolean;
  setShowConsolidated: Function;
}

const Sidebar = ({
  policies,
  activePolicy,
  setActivePolicy,
  setShowConsolidated,
  showConsolidated
}: Props) => {
  const classes = useStyles();

  return (
    <aside className={classes.container}>
      <div className={classes.list}>
        <ul style={{ padding: '0' }}>
          {policies.map(({ owner, display_name, id }) => {
            const isActive = id === activePolicy && !showConsolidated;
            return (
              <li
                key={id}
                className={classNames(
                  classes.policy,
                  isActive && classes.active
                )}
                onClick={() => {
                  setActivePolicy(id);
                  setShowConsolidated(false);
                }}
              >
                <span className={classes.title}>{owner.display_name}</span>
                <span className={classes.subtitle}>{display_name}</span>
              </li>
            );
          })}
        </ul>
        {policies.length > 1 && (
          <div style={{ borderTop: '1px solid #d4d4d4' }}>
            <div
              className={classNames(
                classes.policy,
                showConsolidated && classes.active
              )}
              onClick={() => {
                setActivePolicy(null);
                setShowConsolidated(true);
              }}
            >
              <span className={classes.title}>Consolidated View</span>
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
